<template>
    <div>



        <v-card
                flat
                max-width="204"
                style="background:transparent;"
                class="mx-auto"
                min-width="204"
        >








            <v-card-text @mouseleave="unlift" @mouseover="lift" class="pb-0 pa-0">

                <v-card :class="animation" elevation="20" dark raised :style="{ backgroundImage: `url('${background_image}')`}" style="background-size:cover;cursor:pointer;" height="284" width="204">
                    <img :src="streamer_image"  @load="total_load+=1" style="z-index: 1; position: absolute; width: 154px; top: 34px; left: 25px; height: 110px;"/>

                    <img :src="decorator_image" @load="total_load+=1" style="z-index:2;height:100%;width:100%;background-size:cover;position: absolute;"/>

                </v-card>

            </v-card-text>
            <v-card-actions style="position:relative;top:10px;" class="pa-0 mt-0">

                <v-btn
                        v-show="animation==='lift'"

                        :color=rank_color
                        tile

                        depressed


                        class="mx-auto"
                >
                    <b>{{data.NAME}}</b>
                </v-btn>




            </v-card-actions>
        </v-card>
    </div>

</template>

<script>
    export default {
        name: "CollectionCardStatic",
        data(){
            return{
                total_load:0,
                animation:"lift",
                isAnimating:false,

            }
        },
        props: {
            "data":Object
        },
        mounted:function(){
            this.lift();
            let self=this;
            setTimeout(function(){
                self.unlift();
            },100)
        },
        computed:{
            loading:function(){
                return this.total_load<2;
            },



            background_image:function(){
                if(this.data["TYPE"]==="TEST"){

                    return `/api/images/cards/collections/sample_fg.png`
                }
                else{
                    return `/api/images/cards/collections/${this.data.COID}/${this.data.cCMID}/bg.jpg`

                }
            },
            decorator_image:function(){
                if(this.data["TYPE"]==="TEST"){
                    return `/api/images/cards/collections/sample_decor.png`
                }
                else{
                    return `/api/images/cards/collections/${this.data.COID}/${this.data.cCMID}/${this.data.RANK_VALUE}.png`
                }
            },
            streamer_image:function(){
                return `/api/images/cards/streamer_images/${this.data.STID}/avatar.png`

            },
            rank_color:function(){
                if(this.data.RANK_VALUE===0){
                    return "green"
                }
                else if(this.data.RANK_VALUE===1){
                    return "blue"
                }
                else if(this.data.RANK_VALUE===2){
                    return "purple"
                }
                else if(this.data.RANK_VALUE===3){
                    return "orange"
                }
                else{
                    return "black"
                }
            },
            rank_text:function(){
                if(this.data.RANK_VALUE===0){
                    return "Vanlig"
                }
                else if(this.data.RANK_VALUE===1){
                    return "Ovanlig"
                }
                else if(this.data.RANK_VALUE===2){
                    return "Epic"
                }
                else if(this.data.RANK_VALUE===3){
                    return "Legendary"
                }
                else{
                    return "Okänd"
                }
            },
            float:function(){
                return (Math.sqrt((this.data.FLOAT_X*this.data.FLOAT_X)+(this.data.FLOAT_Y*this.data.FLOAT_Y))/Math.sqrt(2));
            }
        },

        methods:{
            unlift:function(){
                if(!this.isAnimating){
                    this.animation="unlift";
                }
                else{
                    let self=this;
                    setTimeout(function(){
                        self.animation="unlift";
                    },300)
                }
            },
            lift:function(){
                this.animation="lift";
                this.isAnimating=true;
                let self=this;
                setTimeout(function(){
                    self.isAnimating=false;
                },300)
            }


        }
    }
</script>

<style scoped>

    .unlift {
        transform: translateY(0);
        transition: transform .2s;
    }
    .lift {
        transform: translateY(-80px) rotate(2deg);
        transition: transform .2s;
    }

</style>
